export const SET = '/vehicle/tracker/set';
